import { TDeviceType } from '@cian/ui-kit';

import { TJsonQuery } from '../../../packages/JsonQuery';
import { fetchHybridSearchData } from '../../common/actions/fetchHybridSearchData';
import { fetchTags } from '../../common/actions/filters';
import { setNonGeoParameters } from '../../common/actions/nonGeoParameters';
import { getSearchMeta } from '../../common/services/getSearchMeta/getSearchMeta';
import { TThunkAction } from '../../common/types/redux';
import { ISearchMeta } from '../../common/types/searchMeta';
import { buildSubdomainRedirectUrl } from '../../common/utils/buildSubdomainRedirectUrl';
import { isSubdomainRedirectNeeded } from '../../common/utils/isSubdomainRedirectNeeded';
import { sendSerpFilterAppliedUxfbEvent } from '../../common/uxfb';
import { trackFilterFromChipsApply } from '../tracking';

interface IChangeSubdomainParameters {
  searchMeta: ISearchMeta;
}

const changeSubdomain = async ({ searchMeta }: IChangeSubdomainParameters): Promise<boolean> => {
  if (!isSubdomainRedirectNeeded(searchMeta.subdomain)) {
    return false;
  }

  window.location.assign(buildSubdomainRedirectUrl(searchMeta));

  return true;
};

interface IApplyRegionFilterParameters {
  jsonQuery: TJsonQuery;
  deviceType: TDeviceType;
  pageType: 'Listing' | 'Map';
}

export const applyRegionFilter =
  ({ jsonQuery, deviceType, pageType }: IApplyRegionFilterParameters): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    dispatch(sendSerpFilterAppliedUxfbEvent({ jsonQuery, deviceType }));

    const searchMeta = await getSearchMeta(context, jsonQuery);

    trackFilterFromChipsApply({
      queryString: searchMeta.querystring,
      jsonQuery,
      pageType,
      filterType: 'geo',
    });

    dispatch(setNonGeoParameters(false));

    const hasSubdomainChanged = await changeSubdomain({ searchMeta });

    if (hasSubdomainChanged) {
      return;
    }

    dispatch(fetchHybridSearchData({ updateBounds: true, deviceType }));
    dispatch(fetchTags());
  };
